// Type styles shared across pages, so a hero or a section title reads the same everywhere.

/** The small muted line above a hero title. */
export const HERO_EYEBROW = "text-[13px] font-medium text-muted-foreground";
export const HERO_TITLE = "text-[40px] font-semibold leading-[1.02] tracking-[-0.035em] text-foreground sm:text-6xl";
/** The paragraph under a hero title; pages set its width and top margin. */
export const HERO_LEAD = "text-base leading-7 text-muted-foreground sm:text-lg";
/** A section title on the app page. */
export const SECTION_TITLE = "text-2xl font-semibold tracking-[-0.02em] text-foreground sm:text-[28px]";
